export const timelines = [
  {
    date: "10:20 20/12/2021",
    status: "Đang giao hàng",
  },
  {
    date: "03:28 19-12-2021",
    status: "Đơn hàng đang trung chuyển. Kho Trung Chuyển Gia Lai 81",
  },
  {
    date: "03:13 16-12-2021",
    status: "Đơn hàng đã đến kho Kho Trung chuyển Hà Nội 02",
  },
  {
    date: "23:14 13-12-2021",
    status: "Đơn hàng đã đến kho Bưu Cục 8B Nguyễn Lân-Q.Thanh Xuân-HN",
  },
  {
    date: "23:14 13-12-2021",
    status: "Đang lấy hàng",
  },
  {
    date: "16:27 12-12-2021",
    status: "Đang chuẩn bị hàng",
  },
];
